module.exports = __webpack_public_path__ + "img/9788994343235.219376af.jpg";